import { useQuery } from '@tanstack/react-query';
import { getDemonstrationChartData } from 'services/reactQueryservices';
import { demonstrattionChartDatakey } from 'react_query/query-keys';

const useDemonstrationChartData = (division: string, district: string, upazila: string, union: string, project: string, subActivityIds: string[]) => {
    const { data, isFetching, error } = useQuery({
        queryKey: [demonstrattionChartDatakey, division, district, upazila, union, project, subActivityIds],
        queryFn: () => getDemonstrationChartData(division, district, upazila, union, project, subActivityIds)
    });

    return {
        data,
        isFetching,
        error
    };
}

export default useDemonstrationChartData